import React, { useEffect, useState } from "react";
import { ProgressBar, useTheme } from "react-native-paper";
import { useMarket } from "../Market/hook/useMarket";
import { useMediaQuery } from "react-responsive";
import CardCarrier from "../../common_modules/components/Card/CardCarrier";
import { StyleSheet, View } from "react-native";
import _ from "lodash";
import { useNavigation } from "@react-navigation/native";
import { ScrollView } from "react-native-gesture-handler";
import SearchBarComponent from "../../common_modules/components/SeaarchBar/Searchbar";
import HeaderTitle from "../../navigation/Header/HeaderTitle";
import { Carrier, CategoryType } from "../Market/reducer/state";
import { FETCH_CARRIERS } from "../Market/reducer/actions/loadCarriers.graphql";
import {
  getDisplayHeight,
  isWebPlatform,
  IS_DESKTOP_OR_LAPTOP,
  IS_SMARTPHONE,
  IS_TABLET_OR_MOBILE_DEVICE,
} from "../../common_modules/lib/PlatformDevice";
import Empty from "../../common_modules/components/Empty/Empty";
import { useNotification } from "../../common_modules/providers/Notification/hook/useNotification";
import { useApolloGraphQL } from "../../common_modules/providers/ApolloGraphQL/hook/useGraphqlApolloClient";

let searchDebounceTimer = null;

const CarrierList = ({ route }) => {
  const { uiSettings, saveSettings, selectCarrier, categoryState, storeInfo } =
    useMarket();
  const { client } = useApolloGraphQL();
  const { colors } = useTheme();
  const isSmartPhone = useMediaQuery(IS_SMARTPHONE);
  const isDesktopOrLaptop = useMediaQuery(IS_DESKTOP_OR_LAPTOP);
  const isTabletOrMobileDevice = useMediaQuery(IS_TABLET_OR_MOBILE_DEVICE);
  const [refreshed, setRefreshed] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [endCursor, setEndCursor] = useState(undefined);
  const [carriers, setCarriersData] = useState<Array<Carrier>>([]);
  const [focused, setFocused] = useState(true);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const navigation = useNavigation();
  const { error } = useNotification();

  const where: any = {
    parent: { nodes: [categoryState.selected?.id] },
  };

  if (
    _.includes(
      [CategoryType.local, CategoryType.foreign],
      categoryState.selected?.type
    )
  ) {
    where.country = {
      op: categoryState.selected?.type === CategoryType.local ? "IN" : "NIN",
      values: storeInfo.address.country,
    };
  }

  useEffect(() => {
    const unsubscribe = navigation.addListener("blur", () => {
      setFocused(false);
    });

    return unsubscribe;
  }, [navigation]);

  useEffect(() => {
    (async () => {
      if (!loading || (refreshed && !loading && focused)) {
        try {
          setLoading(true);
          if (!categoryState.loading && storeInfo) {
            const { data } = await client.query({
              query: FETCH_CARRIERS,
              fetchPolicy: "no-cache",
              variables: {
                where,
                search,
                endCursor: !search ? endCursor: null,
              },
            });

            if (data) {
              setEndCursor(!search ? data.productCategories.all.pageInfo.endCursor: undefined);
              setHasMore(!search ? data.productCategories.all.pageInfo.hasNextPage: false);
              const carrierList: Carrier[] = !search ? carriers : [];
              _.forEach(data.productCategories.all.edges, (edge) => {
                carrierList.push({
                  id: edge.node.id,
                  sku: edge.node.sku,
                  name: edge.node.name,
                  saleDiscountUpTo: edge.node.saleDiscountUpTo,
                  saleDiscountUpToMode: edge.node.saleDiscountUpToMode,
                  color: edge.node.bgColor || "#26A69A",
                  logoUrl:
                    edge.node.logoUrl ||
                    "data:image/jpeg;base64,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",
                });
              });

              if (carrierList && carrierList.length === 1 && (search === undefined || search === null || search === "")) {
                console.log(carrierList[0])
                selectCarrier(carrierList[0]);
                navigation.navigate("Products", carrierList[0]);
                return;
              }

              setCarriersData(carrierList);
              setLoading(false);
              setRefreshed(false);
            }
          }
        } catch (e) {
          error(e.message);
          setLoading(false);
        }
      }
    })();
  }, [search, refreshed, focused]);

  const loadMore = () => {
    if (focused && !loading && hasMore) {
      setRefreshed(true);
    }
  };

  const handleSearch = (search) => {
    if (!search) {
      setEndCursor(undefined);
      setHasMore(false);
      setCarriersData([]);
    }
    setSearch(search.toLowerCase());
  };

  const toggleFavoriteCarrier = (id: string) => {
    let favoriteCarriers = []
    if (uiSettings.favoriteCarriers) {
      favoriteCarriers = Array.from(uiSettings.favoriteCarriers);
    }
    if (favoriteCarriers.includes(id)) {
      const index = favoriteCarriers.findIndex((fav) => fav === id);
      favoriteCarriers.splice(index, 1);
    } else {
      favoriteCarriers.push(id);
    }
    saveSettings({ ...uiSettings, favoriteCarriers });
  };

  const isFavorite = (carrierId: string) =>
    uiSettings.favoriteCarriers &&
    uiSettings.favoriteCarriers.includes(carrierId);

  const isCloseToBottom = ({
    layoutMeasurement,
    contentOffset,
    contentSize,
  }) => {
    const paddingToBottom = 5;
    return (
      layoutMeasurement.height + contentOffset.y >=
      contentSize.height - paddingToBottom
    );
  };

  return (
    <>
      <HeaderTitle title={categoryState.selected?.name} />
      <SearchBarComponent search={search} onSearch={handleSearch} />
      {loading ? <ProgressBar indeterminate color={colors.primary} /> : null}
      {carriers.length ? (
        <ScrollView
          onScroll={({ nativeEvent }) => {
            if (
              isCloseToBottom(nativeEvent) &&
              focused &&
              hasMore &&
              !loading
            ) {
              loadMore();
            }
          }}
          scrollEventThrottle={400}
          style={{ height: isWebPlatform() ? getDisplayHeight() * 0.6 : null }}
        >
          <View
            style={[
              styles.container,
              {
                marginLeft: !isTabletOrMobileDevice ? "5%" : 15,
                marginRight: !isTabletOrMobileDevice ? undefined : 15,
                marginTop: !isTabletOrMobileDevice ? "3%" : 15,
                marginBottom: !isSmartPhone ? "3%" : "10%",
                justifyContent: isDesktopOrLaptop
                  ? "flex-start"
                  : "space-between",
              },
            ]}
          >
            {carriers.map((carrier, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "column",
                  marginBottom: 10,
                  marginRight: !isTabletOrMobileDevice ? 20 : 0,
                  width: !isDesktopOrLaptop
                    ? isSmartPhone
                      ? "48%"
                      : "28%"
                    : "18%",
                }}
              >
                <CardCarrier
                  key={carrier.id}
                  carrier={carrier}
                  selectCarrier={selectCarrier}
                  isFavorite={isFavorite(carrier.id)}
                  toggleFavoriteCarrier={toggleFavoriteCarrier}
                />
              </View>
            ))}
          </View>
        </ScrollView>
      ) : (
        <Empty target={"carriers"} />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    flex: 1,
  },
});

export default CarrierList;
